import { useEffect, useRef, useCallback, RefObject } from 'react';

type UseInfiniteScroll = (callback: () => void, offset?: number) => RefObject<HTMLDivElement>;

export const useInfiniteScroll: UseInfiniteScroll = (callback, offset = 100) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(() => {
    const container = containerRef.current;
    if (!container) return;

    if (container.scrollHeight - container.scrollTop <= container.clientHeight + offset) {
      callback();
    }
  }, [callback, offset]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return containerRef;
};
